<template>
  <div></div>
</template>

<script>
import AuthService from '../services/Auth';
const authService = new AuthService();
export default {
  mounted() {
    this.clear();
  },
  methods: {
    clear() {
      authService.logOut();
      this.$router.push("/");
    }
  }
};
</script>
